var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHoverMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FEDA46",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.6668C8.31792 18.6668 5.33325 15.6822 5.33325 12.0002C5.33325 8.31816 8.31792 5.3335 11.9999 5.3335C15.6819 5.3335 18.6666 8.31816 18.6666 12.0002C18.6666 15.6822 15.6819 18.6668 11.9999 18.6668ZM11.9999 17.3335C13.4144 17.3335 14.771 16.7716 15.7712 15.7714C16.7713 14.7712 17.3333 13.4147 17.3333 12.0002C17.3333 10.5857 16.7713 9.22912 15.7712 8.22893C14.771 7.22873 13.4144 6.66683 11.9999 6.66683C10.5854 6.66683 9.22888 7.22873 8.22868 8.22893C7.22849 9.22912 6.66659 10.5857 6.66659 12.0002C6.66659 13.4147 7.22849 14.7712 8.22868 15.7714C9.22888 16.7716 10.5854 17.3335 11.9999 17.3335ZM11.3333 8.66683H12.6666V10.0002H11.3333V8.66683ZM11.3333 11.3335H12.6666V15.3335H11.3333V11.3335Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHoverMessage);
export default __webpack_public_path__ + "static/media/icon_hover_message.3a18b199ae9b965fd2cd8c4f1ca2722f.svg";
export { ForwardRef as ReactComponent };